import {
  AVAILABILITY_CHECK_ERROR,
  OPERATIONS_OUTSIDE_BUSINESS_HOURS,
  PRICING_RANGES_NOT_UPDATED,
} from '@fingo/lib/constants/factoring/operation-unavailability-codes';

const AVAILABLE_OFFERS_INFORMATION_NOT_BLOCKED = 'Días parten desde hoy';

const OPERATIONS_OUTSIDE_BUSINESS_HOURS_MESSAGE = 'El ingreso de operaciones está habilitado de lunes a viernes, entre las 9:00 y las 17:00 horas.';

const PRICING_RANGES_NOT_UPDATED_MESSAGE = 'La información de tasas aún no se ha actualizado al día de hoy.';

const AVAILABILITY_CHECK_ERROR_MESSAGE = 'No pudimos verificar la disponibilidad del servicio. Podrás enviar la operación cuando se pueda verificar.';

export const AVAILABLE_OFFERS_INFORMATION_BY_UNAVAILABILITY_CODE = {
  [OPERATIONS_OUTSIDE_BUSINESS_HOURS]: OPERATIONS_OUTSIDE_BUSINESS_HOURS_MESSAGE,
  [PRICING_RANGES_NOT_UPDATED]: PRICING_RANGES_NOT_UPDATED_MESSAGE,
  [AVAILABILITY_CHECK_ERROR]: AVAILABILITY_CHECK_ERROR_MESSAGE,
};

const AVAILABLE_OFFERS_INFORMATION_BLOCKED_FALLBACK = OPERATIONS_OUTSIDE_BUSINESS_HOURS_MESSAGE;

export { AVAILABLE_OFFERS_INFORMATION_BLOCKED_FALLBACK };

export const getAvailableOffersInformationStackMessage = (isBlocked, unavailabilityCode) => {
  if (!isBlocked) {
    return AVAILABLE_OFFERS_INFORMATION_NOT_BLOCKED;
  }
  return AVAILABLE_OFFERS_INFORMATION_BY_UNAVAILABILITY_CODE[unavailabilityCode]
    ?? AVAILABLE_OFFERS_INFORMATION_BLOCKED_FALLBACK;
};
